module.exports = __webpack_public_path__ + "img/php-project.d623d85b.png";